import React, { useCallback, useEffect, useState } from 'react';

import { useWeb3React } from '@web3-react/core';
import { ethers } from 'ethers';

import abiERC1155 from '../../constants/sourceContract/abi/abiERC1155.json';

function BalanceOf({ tokenID, contractAddress, accountAddress }) {
    const { account, library, chainId } = useWeb3React();
    const [signer, setSigner] = useState();
    const [balanceOf, setBalanceOf] = useState('0');

    const getBalanceOf = useCallback(async () => {
        const contract = new ethers.Contract(
            contractAddress,
            abiERC1155,
            signer
        );
        let balanceOf = await contract.balanceOf(
            accountAddress ?? account,
            tokenID
        );
        return (balanceOf = Number.parseInt(balanceOf));
    }, [contractAddress, signer, account, accountAddress, tokenID]);

    useEffect(() => {
        if (!!account && !!library) {
            setSigner(library.getSigner());
        }
    }, [account, library, chainId]);
    useEffect(() => {
        if (!!account && !!library && !!signer) {
            getBalanceOf().then((result) => setBalanceOf(result));
        }
    }, [signer, account, library, getBalanceOf]);

    return <span>{balanceOf}</span>;
}

export default BalanceOf;
